var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1619 71.9868V60.3014C73.1619 48.616 82.4824 39.0172 94.307 39.0172C105.853 39.0172 115.452 48.4768 115.452 60.3014V71.9868",
    stroke: "#C7D2DD",
    strokeWidth: 2.63492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 158.793C146.057 158.515 146.196 158.236 146.752 158.097",
    stroke: "#FF78B7",
    strokeWidth: 0.851784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7325 169.922H180",
    stroke: "#B1B9CC",
    strokeWidth: 2.78224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 169.922H23.2205",
    stroke: "#B1B9CC",
    strokeWidth: 2.78224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.073 49.868H37.549V168.67H156.073V49.868Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.351 49.868H70.5188V168.67H156.212V49.868H156.351Z",
    fill: "#E6ECF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9642 49.868H37.549V168.67H53.9642V49.868Z",
    fill: "url(#paint0_linear_86_2293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5186 168.67H37.549V168.392L54.2424 151.837L70.5186 168.67Z",
    fill: "#E6ECF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2466 76.2993C93.6115 76.2993 95.559 74.3517 95.559 71.9868C95.559 69.6219 93.6115 67.6743 91.2466 67.6743C88.8817 67.6743 86.9341 69.6219 86.9341 71.9868C86.9341 74.3517 88.8817 76.2993 91.2466 76.2993Z",
    fill: "#C7D2DD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.536 76.2993C135.901 76.2993 137.849 74.3517 137.849 71.9868C137.849 69.6219 135.901 67.6743 133.536 67.6743C131.172 67.6743 129.224 69.6219 129.224 71.9868C129.363 74.3517 131.172 76.2993 133.536 76.2993Z",
    fill: "#C7D2DD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2463 71.9868V60.3014C91.2463 48.616 100.567 39.0172 112.391 39.0172C123.938 39.0172 133.536 48.4768 133.536 60.3014V71.9868",
    stroke: "#C7D2DD",
    strokeWidth: 2.63492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.022 34.2312C150.026 32.3055 153.569 31.2271 157.344 31.2271C167.666 31.2271 176.062 39.5462 176.062 49.8681C176.062 60.19 167.666 68.5092 157.344 68.5092C147.022 68.5092 138.626 60.19 138.626 49.8681C138.472 43.3206 141.861 37.6205 147.022 34.2312Z",
    fill: "url(#paint1_linear_86_2293)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.341 58.2147C153.581 58.2147 150.386 54.8385 150.386 49.7742C150.386 44.7099 153.581 41.5212 157.341 41.5212C161.101 41.5212 164.297 44.7099 164.297 49.7742C164.297 54.8385 161.101 58.2147 157.341 58.2147ZM157.341 54.2758C158.657 54.2758 159.973 52.9628 159.973 49.7742C160.161 46.7731 158.657 45.2726 157.341 45.2726C156.025 45.2726 154.709 46.7731 154.709 49.7742C154.709 52.9628 156.025 54.2758 157.341 54.2758Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0032 110.103C94.2245 110.103 90.2104 107.046 88.6813 102.651C88.299 101.695 88.8724 100.74 89.8281 100.358C90.7839 99.9753 91.7396 100.549 92.1219 101.504C93.0776 104.37 95.9448 106.472 99.0032 106.472C102.062 106.472 104.929 104.561 105.884 101.504C106.267 100.549 107.222 99.9753 108.178 100.358C109.134 100.74 109.707 101.695 109.325 102.651C107.796 107.237 103.782 110.103 99.0032 110.103Z",
    fill: "#ADB6C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.867 110.103C123.088 110.103 119.074 107.046 117.545 102.651C117.162 101.695 117.736 100.74 118.692 100.358C119.647 99.9753 120.603 100.549 120.985 101.504C121.941 104.37 124.808 106.472 127.867 106.472C130.925 106.472 133.792 104.561 134.748 101.504C135.13 100.549 136.086 99.9753 137.042 100.358C137.997 100.74 138.571 101.695 138.189 102.651C136.659 107.237 132.645 110.103 127.867 110.103Z",
    fill: "#ADB6C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.531 133.5C115.959 133.5 117.927 131.532 117.927 129.105C117.927 126.677 115.959 124.71 113.531 124.71C111.102 124.71 109.134 126.677 109.134 129.105C109.134 131.532 111.102 133.5 113.531 133.5Z",
    fill: "#ADB6C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4621 36.4683V30H58.4607V36.4683L41.4028 57.0491H58.7548V63.5173H32.5798V57.0491L49.6377 36.4683H33.4621Z",
    fill: "url(#paint2_linear_86_2293)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0492 84.9801V80.8639H70.2248V84.9801L59.343 98.2106H70.5189V102.327H53.461V98.2106L64.3428 84.9801H54.0492Z",
    fill: "url(#paint3_linear_86_2293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_2293",
    x1: 45.7203,
    y1: 53.0298,
    x2: 45.7203,
    y2: 166.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_86_2293",
    x1: 157.344,
    y1: 32.5222,
    x2: 157.344,
    y2: 53.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_86_2293",
    x1: 45.6694,
    y1: 31.1644,
    x2: 45.6694,
    y2: 49.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_86_2293",
    x1: 61.9913,
    y1: 81.6095,
    x2: 61.9913,
    y2: 93.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.a508b1c2daeba16802f817e462039aa7.svg";
export { ForwardRef as ReactComponent };